<script setup lang="ts">
interface IProps {
    count?: number;
    itemHeight?: number;
    itemMinWidth?: number;
    itemMaxWidth?: number;
}
const {
    count = 7,
    itemHeight = 28,
    itemMinWidth = 90,
    itemMaxWidth = 160,
} = defineProps<IProps>();

const bulletList = Array(count)
    .fill(0)
    .map((_, i) => ({
        rectWidth: Number(`0.${i}`) * itemMinWidth + itemMaxWidth,
    }));

const itemHeightStyle = computed(() => `${itemHeight}px`);
</script>

<template>
    <div class="bullet-list-container">
        <div v-for="(bullet, key) in bulletList" :key class="bullet-container">
            <span class="circle loading-skeleton" />
            <span
                class="rect loading-skeleton"
                :style="{ width: `${bullet.rectWidth}px` }"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.bullet-list-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 8px 0;
}

.bullet-container {
    display: flex;
    &:not(:last-child) {
        margin-bottom: 8px;
    }
}

.circle {
    height: v-bind(itemHeightStyle);
    width: v-bind(itemHeightStyle);
    border-radius: 100% !important;
    margin-left: 8px;
}
</style>
